import { BasePaginatorDto } from '@diritto/common/base/paginator/paginator.dto';
import {
  ChatChannelResponseDto,
  ChatChannelsResponseDto,
  ChatUnreadCountResponseDto,
  PinnedChatChannelsResponseDto,
} from '@diritto/common/chat/dtos/chat-channel.dto';
import {
  ChatMessagesRequestDto,
  ChatMessagesResponseDto,
  CreateChatMessageRequestDto,
  CreateChatMessageResponseDto,
} from '@diritto/common/chat/dtos/chat-message.dto';
import { Http } from '@diritto/common/utils/requester/http';
import { AxiosRequestConfig } from 'axios';

export class ChatApi {
  constructor(
    protected url: string,
    protected http: Http,
  ) {}

  async getUnreadCount() {
    const res = await this.http.get<ChatUnreadCountResponseDto>(`${this.url}/chat/unread-count`);
    return res.data;
  }

  async putReadChannel(channelId: number) {
    const res = await this.http.put(`${this.url}/chat/channels/${channelId}/read`, {});
    return res.data;
  }

  async getChannels(params: BasePaginatorDto, options?: AxiosRequestConfig) {
    const res = await this.http.get<ChatChannelsResponseDto>(`${this.url}/chat/channels`, {
      params,
      ...options,
    });
    return res.data;
  }

  async getChannel(channelId: number, options?: AxiosRequestConfig) {
    const res = await this.http.get<ChatChannelResponseDto>(`${this.url}/chat/channels/${channelId}`, {
      ...options,
    });
    return res.data;
  }

  async getChannelMessage(channelId: number, chatMessagesRequestDto: ChatMessagesRequestDto) {
    const res = await this.http.get<ChatMessagesResponseDto>(`${this.url}/chat/channels/${channelId}/messages`, {
      params: chatMessagesRequestDto,
    });
    return res.data;
  }

  async postMessage(channelId: number, createChatMessageRequestDto: CreateChatMessageRequestDto) {
    const res = await this.http.post<CreateChatMessageRequestDto, CreateChatMessageResponseDto>(
      `${this.url}/chat/channels/${channelId}/messages`,
      createChatMessageRequestDto,
    );
    return res.data;
  }

  async getPins(options?: AxiosRequestConfig) {
    const res = await this.http.get<PinnedChatChannelsResponseDto>(`${this.url}/chat/pin/channels`, {
      ...options,
    });
    return res.data;
  }

  async pinChannel(channelId: number, pin: boolean) {
    const res = await this.http.put(`${this.url}/chat/pin/channels/${channelId}`, { pin });
    return res.data;
  }
}
